let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("htYW6")).then(() => parcelRequire('1IJub'));